/**
 * 1.6.5 "Review visit" (D-1.6.5-6): the button that opens a visit's review — on Today's card, on the close-out line
 * of Needs your attention and on a row of a tenant's History. For whoever may open the review, on a housekeeping
 * visit the app holds (not a visit from before the app, not a Tech Support ticket, which has its own page).
 *
 * 1.6.7 (D-1.6.7-0): on Today's card it sits in the row of buttons for the administrator, the co-administrator and
 * the scheduler (`place="row"`); the crew has it too — read-only — beside the visit's name (`place="aside"`), so the
 * crew's row stays Call and one button. Without `place` it is there for everyone who may review.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { AppointmentRow } from '@shared/api-types';
import { REVIEW_ROW_ROLES, canReviewVisit, reviewPath } from '@shared/review';
import type { Role } from '@shared/roles';

export function ReviewVisitLink({ role, visit, place }: { role: Role | null | undefined; visit: Pick<AppointmentRow, 'appointmentId' | 'unit' | 'program' | 'source'>; place?: 'row' | 'aside' }) {
  const { t } = useTranslation();
  if (!canReviewVisit(role) || visit.source || visit.program === 'TECH') return null;
  if (place && (place === 'row') !== REVIEW_ROW_ROLES.includes(role!)) return null;
  return (
    <Link className="btn secondary sm review-link" to={reviewPath(visit.appointmentId)} aria-label={t('review165.buttonFor', { unit: visit.unit })} data-testid={`review-${visit.appointmentId}`}>
      {t('review165.button')}
    </Link>
  );
}
